var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "justify-content": "space-around" } },
    [
      _c(
        "el-checkbox",
        {
          staticStyle: { margin: "0" },
          attrs: { disabled: _vm.disabled },
          on: {
            change: function($event) {
              return _vm.onChange("electric")
            }
          },
          model: {
            value: _vm.job.electric,
            callback: function($$v) {
              _vm.$set(_vm.job, "electric", $$v)
            },
            expression: "job.electric"
          }
        },
        [_vm._v(_vm._s(_vm.$t("CargoMsg.Electric")) + " ")]
      ),
      _c(
        "el-checkbox",
        {
          staticStyle: { margin: "0", "padding-left": "5px" },
          attrs: { disabled: _vm.disabled },
          on: {
            change: function($event) {
              return _vm.onChange("magnetic")
            }
          },
          model: {
            value: _vm.job.magnetic,
            callback: function($$v) {
              _vm.$set(_vm.job, "magnetic", $$v)
            },
            expression: "job.magnetic"
          }
        },
        [_vm._v(_vm._s(_vm.$t("CargoMsg.Magnetic")) + " ")]
      ),
      _c(
        "el-checkbox",
        {
          staticStyle: { margin: "0", "padding-left": "5px" },
          attrs: { disabled: _vm.disabled },
          on: {
            change: function($event) {
              return _vm.onChange("powder")
            }
          },
          model: {
            value: _vm.job.powder,
            callback: function($$v) {
              _vm.$set(_vm.job, "powder", $$v)
            },
            expression: "job.powder"
          }
        },
        [_vm._v(_vm._s(_vm.$t("CargoMsg.Powder")) + " ")]
      ),
      _c(
        "el-checkbox",
        {
          staticStyle: { "padding-left": "5px" },
          attrs: { disabled: _vm.disabled },
          on: {
            change: function($event) {
              return _vm.onChange("liquid")
            }
          },
          model: {
            value: _vm.job.liquid,
            callback: function($$v) {
              _vm.$set(_vm.job, "liquid", $$v)
            },
            expression: "job.liquid"
          }
        },
        [_vm._v(_vm._s(_vm.$t("CargoMsg.Liquid")) + " ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }